import {
  HIDE_TOAST_MESSAGE,
  SET_ACCOUNT_RESTRICTED_MODAL_DATA,
  SET_CURRENT_NAME,
  SET_DEFAULT_TAPROOT_CURRENCY,
  SET_DEFAULT_WALLET_CURRENCY,
  SET_LOGIN_DATA,
  SET_REDIRECT_URL,
  SET_REGISTER_DATA,
  SET_TRANSACTION_FILTER_DATA,
  SHOW_TOAST_MESSAGE,
  SET_ACCOUNT_CURRENCY,
  SET_SHOW_BTC_AMOUNT,
  SET_MAINTENANCE_MODAL_OPEN,
  SET_MAINTENANCE_FLAG,
  SET_IS_HIDE_UNDER_MAINTENANCE_BAR,
  SET_PAY_VIA_METHODS,
  SET_APP_DETAILS,
  SET_OPEN_APP_DETAIL_MODAL,
  SET_IS_OPEN_INSTALLED_APP_DIALOG,
  SET_MY_APPS_DATA,
  SET_COLLECTION_DATA,
  SET_CATEGORY_DATA,
  SET_APP_LIST,
  SET_NEW_ADDRESS_OBJ,
  SET_SEND_TO_CONTACT_DATA,
} from "./types";

const initialState = {
  registerDetails: null,
  loginDetails: null,
  redirectUrl: "",
  isToastOpen: false,
  toastMessage: "",
  toastVariant: "success",
  toastAutoHideDuration: 4000,
  notificationClass: "",
  currentAccount: null,
  currentAccountName: null,
  taprootAsset: JSON.parse(localStorage.getItem("default_taproot_asset")),
  walletCurrency: JSON.parse(
    localStorage.getItem("default_wallet_currency")
  ) || { name: "US Dollar", code: "USD", symbol: "$" },
  transactionFilterData: {},
  accountRestrictedModalData: {},
  accountAssets: [],
  showBtcAmount: false,
  maintenanceModalOpen: false,
  maintenance: false,
  isHideUnderMaintenanceBar: true,
  payViaMethods: {},
  isAppDetailOpen: false,
  appDetails: {},
  isOpenInstalledAppDialog: false,
  myApps: [],
  collectionData: [],
  appList: [],
  categories: [],
  newAddressObj: {},
  sendToContactData: {},
};

const common = (state = initialState, action) => {
  switch (action.type) {
    case SET_REGISTER_DATA:
      return {
        ...state,
        registerDetails: {
          email: action.payload.email,
          password: action.payload.password,
        },
      };
    case SET_LOGIN_DATA:
      return {
        ...state,
        loginDetails: {
          email: action.payload.email,
        },
      };
    case SET_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.payload,
      };
    case SHOW_TOAST_MESSAGE:
      return {
        ...state,
        isToastOpen: action.payload.isToastOpen,
        toastMessage: action.payload.toastMessage,
        toastVariant: action.payload.toastVariant,
        toastAutoHideDuration: action.payload.toastAutoHideDuration || 4000,
        notificationClass: action.payload.className,
      };
    case HIDE_TOAST_MESSAGE:
      return {
        ...state,
        isToastOpen: false,
      };

    case SET_CURRENT_NAME:
      return {
        ...state,
        currentAccountName: action.payload?.name,
      };

    case SET_DEFAULT_TAPROOT_CURRENCY:
      localStorage.setItem(
        "default_taproot_asset",
        JSON.stringify(action?.payload)
      );
      return {
        ...state,
        taprootAsset: action?.payload,
      };

    case SET_DEFAULT_WALLET_CURRENCY:
      localStorage.setItem(
        "default_wallet_currency",
        JSON.stringify(action?.payload)
      );
      return {
        ...state,
        walletCurrency: action?.payload,
      };

    case SET_TRANSACTION_FILTER_DATA:
      return {
        ...state,
        transactionFilterData: action.payload,
      };

    case SET_ACCOUNT_RESTRICTED_MODAL_DATA:
      return {
        ...state,
        accountRestrictedModalData: action.payload,
      };
    case SET_ACCOUNT_CURRENCY:
      return {
        ...state,
        accountAssets: action.payload,
      };
    case SET_SHOW_BTC_AMOUNT:
      return {
        ...state,
        showBtcAmount: action.payload,
      };
    case SET_MAINTENANCE_MODAL_OPEN:
      return {
        ...state,
        maintenanceModalOpen: action.payload,
      };
    case SET_MAINTENANCE_FLAG:
      return {
        ...state,
        maintenance: action.payload,
      };
    case SET_IS_HIDE_UNDER_MAINTENANCE_BAR:
      return {
        ...state,
        isHideUnderMaintenanceBar: action.payload,
      };
    case SET_PAY_VIA_METHODS:
      return {
        ...state,
        payViaMethods: action.payload,
      };
    case SET_OPEN_APP_DETAIL_MODAL:
      return {
        ...state,
        isAppDetailOpen: action.payload,
      };
    case SET_APP_DETAILS:
      return {
        ...state,
        appDetails: action.payload,
      };
    case SET_IS_OPEN_INSTALLED_APP_DIALOG:
      return {
        ...state,
        isOpenInstalledAppDialog: action.payload,
      };
    case SET_MY_APPS_DATA:
      return {
        ...state,
        myApps: action.payload,
      };
    case SET_COLLECTION_DATA:
      return {
        ...state,
        collectionData: action.payload,
      };
    case SET_CATEGORY_DATA:
      return {
        ...state,
        categories: action.payload,
      };

    case SET_APP_LIST:
      return {
        ...state,
        appList: action.payload,
      };

    case SET_NEW_ADDRESS_OBJ:
      return {
        ...state,
        newAddressObj: action.payload,
      };
    case SET_SEND_TO_CONTACT_DATA:
      return {
        ...state,
        sendToContactData: action.payload,
      };
    default:
      return state;
  }
};

export default common;
